// TODO: compare to components/badges/StatusBadge/StatusBadge
import React from "react"
import PropTypes from "prop-types"
import { Tooltip } from "antd"
import "./SuccessBadge.scss"

const SuccessBadge = ({ variant = "fail", style = {}, className, tooltip }) => {
  const getIconClass = (variant) => {
    if (variant === "success") return "fas fa-check-circle"
    if (variant === "warning") return "fas fa-exclamation-triangle"
    if (variant === "unknown") return "fas fa-circle-question"
    return "fas fa-minus-circle" // default, eg, "new", "fail"
  }

  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <i
          className={`status-badge ${getIconClass(variant)}${variant ? " " + variant : ""}${
            className ? " " + className : ""
          }`}
          style={style}
          variant={variant}
        />
      </Tooltip>
    )
  }

  return (
    <i
      className={`status-badge ${getIconClass(variant)}${variant ? " " + variant : ""}${
        className ? " " + className : ""
      }`}
      style={style}
      variant={variant}
    />
  )
}

SuccessBadge.propTypes = {
  variant: PropTypes.oneOf(["success", "fail", "new", "error", "warning", "unknown"]),
  style: PropTypes.object,
  className: PropTypes.string,
  tooltip: PropTypes.string,
}

export default SuccessBadge
